import {Alert} from '../../../core/model/alert';

export interface AlertsState {
  alerts: Alert[];
  unreadAlertsCount: number;
}

export const initialAlertsState: AlertsState = {
  alerts: null,
  unreadAlertsCount: 0,
};
